import moment from 'moment';
import { DateTimeInputFormat } from '../dispatch/Dispatch';

export class LongTermScheduleDayCancelApiRequest {
    longTermScheduleId = 0;
    date = new Date();
    longTermScheduleDayCancelOptionId = 0;
    requestedRescheduleDate = null;

    assignmentId = 0;
    cancellationTypeId = 0;
    cancellationNote = '';

    cancellationTime = DateTimeInputFormat(new Date());
}

export const isRequestedRescheduleDateValid = (cancelRequest, eventDate) =>
    cancelRequest &&
    cancelRequest.requestedRescheduleDate &&
    moment(cancelRequest.requestedRescheduleDate).isSameOrAfter(
        moment(eventDate).add(1, 'day')
    );
